export default "__VITE_ASSET__bfe753f2__"